import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const cartPageAPI = createApi({
  reducerPath: "cartPageAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,
    prepareHeaders: (headers, { getState }) => {
      const accessToken = localStorage.getItem("access_token"); // For logged-in users
      const guestCartToken = localStorage.getItem("cartToken"); // For guest users

      // if (accessToken) {
      //   headers.set("Authorization", `Bearer ${accessToken}`);
      // } else if (guestCartToken) {
      //   headers.set("Cart-Token", guestCartToken);
      // }

      // First set Cart-Token to empty string by default
      headers.set("Cart-Token", "");

      if (accessToken) {
        // For logged-in users, remove Cart-Token and set Authorization
        headers.delete("Cart-Token");
        headers.set("Authorization", `Bearer ${accessToken}`);
      } else if (
        guestCartToken &&
        guestCartToken !== "null" &&
        guestCartToken !== "undefined"
      ) {
        // For guest users with valid cart token
        headers.set("Cart-Token", guestCartToken);
      }
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getCartData: builder.query({
      query: () => `user/cart/display-cart`,
    }),

    updateCartQuantity: builder.mutation({
      query: (body) => {
        // Prepare request body based on user authentication status
        const accessToken = localStorage.getItem("access_token");
        const requestBody = {
          product_id: body.product_id,
          quantity: body.quantity,
        };

        // Only add user_id if user is logged in
        if (accessToken) {
          const userId = localStorage.getItem("gridMarker"); // Assuming you store user_id
          if (userId) {
            requestBody.user_id = userId;
          }
        }

        return {
          url: "user/cart/add-to-cart",
          method: "POST",
          body: requestBody,
        };
      },
    }),

    reduceCartQuantity: builder.mutation({
      query: (body) => {
        // Prepare request body based on user authentication status
        const accessToken = localStorage.getItem("access_token");
        const requestBody = {
          product_id: body.product_id,
        };

        // Only add user_id if user is logged in
        if (accessToken) {
          const userId = localStorage.getItem("gridMarker"); // Assuming you store user_id
          if (userId) {
            requestBody.user_id = userId;
          }
        }

        return {
          url: "user/cart/reduce-quantity",
          method: "POST",
          body: requestBody,
        };
      },
    }),

    removeCartItem: builder.mutation({
      query: (body) => {
        // Prepare request body based on user authentication status
        const accessToken = localStorage.getItem("access_token");
        const requestBody = {
          product_id: body.product_id,
        };

        // Only add user_id if user is logged in
        if (accessToken) {
          const userId = localStorage.getItem("gridMarker"); // Assuming you store user_id
          if (userId) {
            requestBody.user_id = userId;
          }
        }

        return {
          url: "user/cart/remove-cart-item",
          method: "POST",
          body: requestBody,
        };
      },
    }),

    applyCoupon: builder.mutation({
      query: (body) => {
        // Prepare request body based on user authentication status
        const accessToken = localStorage.getItem("access_token");
        const requestBody = {
          coupon_code: body.coupon_code,
        };

        // Only add user_id if user is logged in
        if (accessToken) {
          const userId = localStorage.getItem("gridMarker"); // Assuming you store user_id
          if (userId) {
            requestBody.user_id = userId;
          }
        }

        return {
          url: "user/cart/apply-coupon",
          method: "POST",
          body: requestBody,
        };
      },
    }),

    placeOrder: builder.mutation({
      query: (body) => {
        const accessToken = localStorage.getItem("access_token");
        const userId = localStorage.getItem("gridMarker");

        // Prepare the request body
        const requestBody = {
          cart_id: body.cart_id,
          payment_type: body.payment_type,
          first_name: body.first_name,
          last_name: body.last_name,
          company_name: body.company_name,
          country: body.country,
          street_address: body.street_address,
          town_city: body.town_city,
          state: body.state,
          pin_code: body.pin_code,
          phone: body.phone,
          email: body.email,
          account_create: body.account_create,
          diff_ship_address: body.diff_ship_address,
          order_notes: body.order_notes,
        };

        // Add user_id if the user is logged in
        if (accessToken && userId) {
          requestBody.user_id = userId;
        }

        // Add shipping address fields if diff_ship_address is true
        if (body.diff_ship_address) {
          requestBody.ship_first_name = body.ship_first_name;
          requestBody.ship_last_name = body.ship_last_name;
          requestBody.ship_company_name = body.ship_company_name;
          requestBody.ship_country = body.ship_country;
          requestBody.ship_street_address = body.ship_street_address;
          requestBody.ship_town_city = body.ship_town_city;
          requestBody.ship_state = body.ship_state;
          requestBody.ship_pin_code = body.ship_pin_code;
          requestBody.ship_phone = body.ship_phone;
          requestBody.ship_email = body.ship_email;
        }

        // Add payment method ID only if payment type is 0 (Stripe)
        if (body.payment_type === 0) {
          requestBody.paymentMethodId = body.paymentMethodId;
        }

        return {
          url: "user/orders/make-order", // Adjust the URL as per your API
          method: "POST",
          body: requestBody,
        };
      },
    }),
    getCartCount: builder.query({
      query: () => `cart-count`,
    }),

    transferCart: builder.mutation({
      query: (formData) => ({
        url: "user/cart/transfer-cart",
        method: "POST",
        body: formData,
      }),
    }),
    getActiveShiipingOption: builder.query({
      query: () => `active-shipping-options`,
    }),
  }),
});

export const {
  useGetCartDataQuery,
  useUpdateCartQuantityMutation,
  useReduceCartQuantityMutation,
  useRemoveCartItemMutation,
  useApplyCouponMutation,
  usePlaceOrderMutation,
  useGetCartCountQuery,
  useTransferCartMutation,
  useGetActiveShiipingOptionQuery
} = cartPageAPI;
